import { usePageViewedEvent } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';

export const useOnboardingConfirmationViewed = (isProgynyRxView: boolean, origin?: string) => {
  usePageViewedEvent({
    event: EVENTS.ONBOARDING__CONFIRMATION_VIEWED,
    params: {
      origin,
      is_progyny_rx_view: isProgynyRxView,
    },
  });
};
